export default function TextField({ question, value, onChange, error }) {
  const isPhone = question.type === "phone";
  const inputType = isPhone ? "tel" : question.type === "email" ? "email" : "text";
  const placeholder =
    question.placeholder ||
    (question.type === "email" ? "email@contoh.com" : "Ketik jawaban Anda...");

  const input = (
    <input
      type={inputType}
      value={value || ""}
      onChange={(e) => {
        let next = e.target.value;
        if (isPhone) next = next.replace(/[^0-9]/g, "");
        if (question.filter) next = question.filter(next);
        onChange(question.id, next);
      }}
      maxLength={question.validation?.maxLength}
      placeholder={placeholder}
      className={`w-full px-5 py-3.5 rounded-xl bg-white/5 border text-white placeholder-white/40
        font-sans text-sm desktop:text-base outline-none transition-all duration-300
        focus:bg-white/10 focus:ring-2 focus:ring-white/20
        ${error ? "border-red" : "border-white/20 focus:border-white/40"}`}
    />
  );

  if (isPhone) {
    return (
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2">
          <span className="px-3 py-3.5 rounded-xl bg-white/10 text-white/60 font-sans text-sm desktop:text-base border border-white/20 select-none">
            +62
          </span>
          {input}
        </div>
      </div>
    );
  }

  return <div className="flex flex-col gap-2">{input}</div>;
}